import { createSelector } from '@reduxjs/toolkit';

const selectUsersState = (state) => state.users;

export const selectSearchedUserIds = () => createSelector(selectUsersState, (usersState) => usersState.searchedUserIds);
